import appReducer from "../reducers";
import { createStore, compose, applyMiddleware } from "redux";

import { persistStore, persistReducer } from 'redux-persist'

import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'

const persistConfig = {
    key: 'root',
    storage,
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistedReducer = persistReducer(persistConfig, appReducer)
const appMiddleware = applyMiddleware();

const store = createStore(
    persistedReducer,
    composeEnhancers(appMiddleware)
)
const persistor = persistStore(store);
export { store, persistor }



//  ------------------------------------------ Without Persist Store -----------------------------------------------


// const appMiddleware = applyMiddleware();
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const appStore = createStore(appReducer, composeEnhancers(appMiddleware));


// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const appMiddleware = applyMiddleware();

// export const store = createStore(
//     appReducer,
//     composeEnhancers(appMiddleware)
// );






